import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { EntityType } from '../../services/direct';
import { Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useRefundDetails } from '../../hooks/useRefundDetails';

export function EntityTypePicker() {
  const { t } = useTranslation();
  const { entityType } = useSearch({ strict: false });
  const navigate = useNavigate();
  const { data } = useRefundDetails();

  if (
    !data?.refundData?.isCustomPaymentTypesEnabled ||
    data?.refundData?.entity_type !== EntityType.UNKNOWN
  ) {
    return null;
  }

  const handleSelectChange = (value: EntityType) => {
    navigate({
      to: '/payments/payment-methods',
      search: (prev) => ({
        ...prev,
        entityType: value,
        paymentType: undefined,
        step: prev.step ?? 0,
      }),
    });
  };

  const valueToDisplay: Record<EntityType, string> = {
    [EntityType.INDIVIDUAL]: t('Individual'),
    [EntityType.BUSINESS]: t('Business'),
    [EntityType.UNKNOWN]: t('Unknown'),
  };

  return (
    <div className='flex items-center gap-2'>
      <Select value={entityType} onValueChange={handleSelectChange}>
        <SelectTrigger className='w-36 bg-transparent'>
          <SelectValue placeholder={t('Entity Type')}>
            <div className='flex items-center gap-3'>
              <Users className='h-4 w-4 text-foreground' />
              {entityType ? valueToDisplay[entityType] : ''}
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={EntityType.INDIVIDUAL}>
            {t('Individual')}
          </SelectItem>
          <SelectItem value={EntityType.BUSINESS}>{t('Business')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
